import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getExtendedStayListings } from './actions';
import { renderCard } from './featured-listings-component';

const mapStateToProps = state => ({
  extendedStayListings: state.BrowseListings.extendedStayListings
});

class ExtendedStayListings extends Component {
  constructor(props) {
    super(props);

    this.retrieveListings = this.retrieveListings.bind(this);
  }

  componentDidMount() {
    this.retrieveListings();
  }

  retrieveListings = () => {
    this.props.dispatch(getExtendedStayListings());
  }

  render() {
    const { extendedStayListings } = this.props;

    if (!extendedStayListings.length)
      return (<div className="text-center w-100">There are currently no such Listings near your desired location.
        Please check back soon, as new listings are added frequently.</div>);

    return (
      <div className="feature-listing-section">
        <div className="featured-head">
          <div className="head-left">
            <h2 className="featured-title">Extended Stay Listings</h2>
            <p className="pg-content">Check out these great listings that offer extended stay options.</p>
          </div>
        </div>
        <div className="featured-lisiting-grid-section">
          <div className="card-section">
            {extendedStayListings.map(renderCard)}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(ExtendedStayListings);
